const isProd = process.env.NODE_ENV === "production";
const logOutput = isProd || true; // always log in production, set true/false to log in local

// TODO: make this dynamic based on the environment
// TODO: test with firebase httpsCallable
const checkSubscriptionFunctionURL = isProd
	? "https://us-central1-aadojo-8bbac.cloudfunctions.net/checksubscription"
	: "http://127.0.0.1:5001/test-preflopmastery/us-central1/checksubscription";

export default async function updateSubscriptionStatus(stripeCustomerID, updateStatusFunction) {
	if (logOutput) console.log("updateSubscriptionStatus customerID passed to function:", stripeCustomerID);

	if (!stripeCustomerID) {
		updateStatusFunction("inactive");
		return { status: "inactive", planType: null };
	}

	const result = await fetch(checkSubscriptionFunctionURL, {
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
		},
		method: "POST",
		body: JSON.stringify({ customerID: stripeCustomerID }),
	});
	const data = await result.json();

	if (logOutput) console.log("updatesubscription status", data);

	updateStatusFunction(data.subscriptionStatus, data.planType);
	return { status: data.subscriptionStatus, planType: data.planType };
}
